import {getFormattedFullLocation} from '@wix/wix-events-commons-statics'
import {ChevronUp} from '@wix/wix-ui-icons-common'
import {useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {useVisibilityStyles} from '../../../../../../../../hooks/use-visibility-styles'
import {getEventBadge, getMultiDayText, getRibbonData} from '../../../../../../../../selectors/events'
import {EventBadge} from '../../../../../../../event-badge'
import {EventImage} from '../../../../../../../event-image'
import {LinkToPage} from '../../../../../../../link-to-page'
import {Members} from '../../../../../../../members'
import {Ribbon} from '../../../../../../../ribbon'
import {RsvpButton} from '../../../../../../../rsvp-button'
import {SocialBar} from '../../../../../../../social-bar'
import {MobileMonthlyEventDetailsProps} from './interfaces'
import s from './mobile-monthly-event-details.scss'

export const MobileMonthlyEventDetails = ({
  event,
  hasImage,
  showMembers,
  date,
  multiDay,
  showRibbon,
  closeMonthlyCalendarEvent,
  state,
  selectedDate,
}: MobileMonthlyEventDetailsProps) => {
  const {t} = useTranslation()
  const {
    allBreakpoints: {isEventBadgeInEventInfo},
  } = useVisibilityStyles()

  const multiDayText = getMultiDayText(state, event.id, selectedDate, t)
  const hasRibbon = getRibbonData(state, event).visible
  const eventBadge = getEventBadge(state, event)

  const handleEventClick = () => {
    closeMonthlyCalendarEvent()
  }

  return (
    <div className={s.container}>
      <div className={s.eventInfo} onClick={handleEventClick} data-hook={`event-details-${event.id}`}>
        {isEventBadgeInEventInfo(eventBadge?.type) && (
          <EventBadge event={event} className={classNames({[s.eventBadge]: !showRibbon || !hasRibbon})} />
        )}
        {showRibbon && <Ribbon event={event} className={s.ribbon} />}
        {multiDay ? (
          <div className={s.time}>{multiDayText}</div>
        ) : (
          <div className={s.fullDate} data-hook="date">
            {date}
          </div>
        )}
        <div
          className={classNames({
            [s.multiDayTitle]: multiDay,
            [s.title]: !multiDay,
          })}
          data-hook="title"
        >
          <LinkToPage event={event}>{event.title}</LinkToPage>
          <div className={s.chevron}>
            <ChevronUp size="1.2em" />
          </div>
        </div>
      </div>
      {hasImage && (
        <div className={s.image}>
          <EventImage event={event} />
        </div>
      )}
      {multiDay && (
        <div className={s.fullDate} data-hook="date">
          {date}
        </div>
      )}
      <div className={s.location} data-hook="location">
        {getFormattedFullLocation(event)}
      </div>
      {showMembers && (
        <div className={s.members} data-hook="members">
          <Members event={event} />
        </div>
      )}
      {event.description && (
        <div className={s.description} data-hook="description">
          {event.description}
        </div>
      )}
      <div className={s.share} data-hook="share">
        <div className={s.shareText}>{t('shareEventText')}</div>
        <SocialBar t={t} spacing={7} event={event} iconFontSize={14} newColors={false} row hideTitle />
      </div>
      <RsvpButton
        event={event}
        dataHook="rsvp-button"
        minWidth={88}
        maxWidth={170}
        minHeight={32}
        additionalStyle={{fontSize: 14}}
        containerClassName={s.button}
      />
    </div>
  )
}
